import { TArrayAxiosResponse } from '@/common/types/response';

import { TUserItem } from '../../types/users';
import { TUsersStoreState } from './types';

export function setUsers(state: TUsersStoreState, res: TArrayAxiosResponse<TUserItem>) {
  state.users = res.data.items;
}
